import {
    ReactElement,
    HTMLAttributes
} from "react";

interface Props extends HTMLAttributes<HTMLElement> {
    title: string;
    isBold?: boolean;
    myStyle?: string;
    contentLoading?: boolean;
}

export function Headline({ title, isBold, myStyle, contentLoading }: Props): ReactElement {
    return (
        <div className={`${myStyle && myStyle} headline`}>

            {contentLoading ? <div className="content-loading"></div> :
                <h5 className={`${isBold ? "headline-title-bold" : "headline-title"}`}>
                    {title}
                </h5>
            }
        </div>
    )
}
export default Headline;